import React from "react";
import CheckEmail from "../auth/CheckEmail";

export default function CheckEmailPage() {
  return <CheckEmail />;
}
